import * as React from "react";

import { getGoogleAdsCustomers } from "../api/google-ads";
import {
  MOCK_GOOGLE_ADS_ACCOUNT,
  MOCK_GOOGLE_ADS_ACCOUNT_NAME,
  isMockEnabled,
} from "../lib/mock";

// Falls back to the id, and reports nothing when the fetch fails: the
// page's own load already surfaces that, and an empty breadcrumb would be
// worse than a number.
export function useGoogleAdsAccountName(
  workspaceSlug: string,
  customerId: string | undefined,
): string {
  const [fetched, setFetched] = React.useState<string | null>(null);
  // Derived rather than fetched, so it belongs in the render and not in
  // state an effect would have to set.
  const mockName = isMockEnabled()
    ? customerId === MOCK_GOOGLE_ADS_ACCOUNT
      ? MOCK_GOOGLE_ADS_ACCOUNT_NAME
      : null
    : null;

  React.useEffect(() => {
    if (!workspaceSlug || !customerId || isMockEnabled()) return;
    let cancelled = false;
    (async () => {
      try {
        const customers = await getGoogleAdsCustomers(workspaceSlug);
        const found = customers.find(({ id }) => id === customerId);
        if (!cancelled && found) {
          setFetched(found.name);
        }
      } catch {
        // Falls back to the id below.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [customerId, workspaceSlug]);

  return mockName ?? fetched ?? customerId ?? "…";
}
